export default __webpack_public_path__ + "static/media/k_wdt_c_5.c82b151c.mp3";